import React from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
import { appendScriptsCallback } from '../../../helpers/Utils';

export function TradingRevenueForecastManualCustomPage(): React.ReactElement {
  const currentSecurity = useSecurity('Trading', 'RevenueForecast');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScriptsCallback(
        [
          'Areas/Trading/Scripts/Resources/en/res.AgencyProfilePeriod.en.js',
          'Areas/Trading/Scripts/Resources/en/res.RevenueForecast.en.js',
          'Areas/Trading/Scripts/Resources/en/res.RevenueStream.en.js',
          'Areas/Trading/Scripts/Resources/en/res.RevenueManualStream.en.js',
          'Areas/Trading/Scripts/Resources/en/res.DealCategory.en.js',
          'Areas/Trading/Scripts/Resources/en/Types.en.js',
          'Areas/Trading/Scripts/Resources/en/res.Trading.en.custom.js',
          'Areas/Trading/Scripts/Enums.js',
          'Areas/Trading/Scripts/jquery.shared.custom.js',
          'Areas/Trading/Scripts/RevenueForecast/IndexManual.custom.js',
          'Areas/Trading/Scripts/RevenueManualStream/View.custom.js'
        ],
        'initSearchRevenueForecastManualIndex',
        {
          canEdit: true,
          canCreate: true,
          canRemove: true,
          mode: 'RevenueManual',
          appSettings: currentSecurity.profile.AppSettings.Values,
        },
      );
    }
  }, []);
  return (
    <div className="panelcontent-section" style={{ display: 'none' }}>
      <div
        id="sidebar-section"
        ref={(el) => {
          if (el) {
            el.style.setProperty('padding', '1em 2em', 'important');
          }
        }}
      >
        <i className="fas fa-bars" id="sidebarBar"></i>
        <div className="k-content">
          <h3>Manual Spends</h3>
          <div className="field shortcontrol-container">
            <label className="required">Forecast Year</label>
            <input id="inputYear" />
          </div>
          <div className="field fullwidth-container">
            <label className="required">Agency</label>
            <input id="inputAgencyProfile" />
          </div>
          <div className="field fullwidth-container">
            <label>Break Criteria</label>
            <input id="inputBreakCriteria" />
          </div>
          <div className="field fullwidth-container">
            <label>Manual Stream</label>
            <input id="inputManualStream" />
          </div>
          <div className="field fullwidth-container">
            <label>Revenue Stream</label>
            <input id="inputRevenueStream" />
          </div>
          <div className="field fullwidth-container">
            <label>Currency</label>
            <input id="inputCurrency" />
          </div>
          <section className="button-toolbar">
            <div className="right">
              <button id="applyFilterButton" type="button" className="k-button k-primary" title="Go">
                Go
              </button>
            </div>
          </section>
        </div>
      </div>
      <div id="content-section" className="collapsed">
        <i className="fas fa-bars" id="contentBar" style={{ display: 'none' }}></i>
        <div id="RevenueManualContainer" className="k-content">
        </div>
      </div>
    </div>
  );
}
